module.exports = {
  painter: require('./painter'),
  getShape: require('./getShape')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g@3.3.6@@antv/g/lib/renderers/svg/index.js
// module id = 226
// module chunks = 0 1 2